"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function(
  $q,
  openFinWebClientApiFactory,
  roccUsageRepository,
  $log
) {
  var that = this;

  var getMenuItemsPromise;

  that.get = function() {
    if (!getMenuItemsPromise) {
      getMenuItemsPromise = createMenuItemsPromise();
    }
    return getMenuItemsPromise;
  };

  function createMenuItemsPromise() {
    return createOpenFinWebClientApi(roccUsageRepository.isUsingRocc()).then(
      function(openFinWebClientApi) {
        return openFinWebClientApi
          .all("menuItems")
          .getList()
          .then(function(menuItems) {
            return menuItems.plain();
          });
      }
    );
  }

  function createOpenFinWebClientApi(isROCC) {
    if (isROCC) {
      $log.info("ROCC environment does not support Eikon functionality.");
      return openFinWebClientApiFactory.create();
    }
    return openFinWebClientApiFactory.createWithEikonTokenHeaderOrWithoutIt();
  }

  that.getByName = function(name, params) {
    return findAndEnrich({ name: name }, params).then(function(
      enrichMenuOrUndefined
    ) {
      return (
        enrichMenuOrUndefined ||
        $q.reject(new Error("Could not find the menu item by name " + name))
      );
    });
  };

  that.getByType = function(type) {
    return findAndEnrich({ type: type }).then(function(enrichMenuOrUndefined) {
      return (
        enrichMenuOrUndefined ||
        $q.reject(new Error("Could not find the menu item by type " + type))
      );
    });
  };

  that.getByEikonAppId = function(eikonAppId) {
    return findAndEnrich({ eikonAppId: eikonAppId }).then(function(
      enrichMenuOrUndefined
    ) {
      return (
        enrichMenuOrUndefined ||
        $q.reject(
          new Error("Could not find the menu item by eikonAppId" + eikonAppId)
        )
      );
    });
  };

  function findAndEnrich(criteria, params) {
    return find(criteria).then(function(menuItemOrUndefined) {
      if (menuItemOrUndefined) {
        return enrichMenuItem(menuItemOrUndefined, params);
      } else {
        return menuItemOrUndefined;
      }
    });
  }

  function find(criteria) {
    return that.get().then(function(menuItems) {
      return _.find(menuItems, criteria);
    });
  }

  function enrichMenuItem(menuItem, params) {
    var enrichedMenuItem = _.clone(menuItem);
    var paramsWithDefaults = _.defaults(params || {}, menuItem.defaultParams);
    var urlTemplate = _.template(enrichedMenuItem.url);
    enrichedMenuItem.url = urlTemplate(paramsWithDefaults);
    return enrichedMenuItem;
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/repositories/menuItemRepository.js